import type { CellContext } from '@tanstack/react-table';
import { formatDate } from './date';

export const SMART_LIST_FIELD_TYPE_DATE = 2;
export const SMART_LIST_FIELD_TYPE_DATETIME = 222;

export function isSmartListDateFieldType(fieldType: number): boolean {
  return fieldType === SMART_LIST_FIELD_TYPE_DATE || fieldType === SMART_LIST_FIELD_TYPE_DATETIME;
}

type ColumnDefWithListFilter = {
  filter?: { type?: number };
};

export function renderSmartListDateCell(ctx: CellContext<any, unknown>): string {
  const raw = ctx.cell.getValue();
  if (raw == null || raw === '') {
    return '';
  }
  const fieldType = (ctx.column.columnDef as ColumnDefWithListFilter).filter?.type;
  const format = fieldType === SMART_LIST_FIELD_TYPE_DATETIME ? 'M/D/YY HH:mm' : 'M/D/YY';
  return formatDate(String(raw), { format });
}
